import api from './api';

export function getUserAutMethods(token) {
    return api.get(`/mfa-auth-methods/${token}`);
}

export function sendEmailCode(token) {
    return api.get(`/mfa-auth/send-email-code/${token}`);
}

export function sendSmsCode(token){
    return api.get(`/mfa-auth/send-sms-code/${token}`);
}

export function verifyEmailCode(values){
    return api.post('/mfa-auth/verify-email', values);
}

export function verifySmsCode(values){
    return api.post('/mfa-auth/verify-sms', values);
}

export function verifyAppCode(values) {
    return api.post('/mfa-auth/verify-app-code', values);
}